<template>
  <section class="stores">
    <el-form ref="form" :model="form" :rules="editFormRules" label-width="180px" label-position="left">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <p class="P_XT" style="">基本信息</p>
        <el-row>
          <el-col :span="7">
            <el-form-item label="岗位号" prop="PostID">
              <el-select
                :disabled="EM_IF == 'CK'"
                v-model="form.PostID"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                clearable
                collapse-tags
                placeholder="请输入"
                @change="crystal_position_change"
              >
                <el-option v-for="item in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="事业部" prop="BU">
              <el-select :disabled="true" v-model="form.BU" placeholder="请选择">
                <!-- <el-option label="白内障" value="白内障"></el-option> -->
                <!-- <el-option label="飞秒激光" value="飞秒激光"></el-option> -->
                <!-- <el-option label="眼表" value="眼表"></el-option> -->
                <!-- <el-option label="白力士" value="白力士"></el-option> -->
                <el-option label="晶体事业部" value="晶体事业部"></el-option>
                <el-option label="飞秒激光及眼表事业部" value="飞秒激光及眼表事业部"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="转岗时间" prop="Reorientation_Date">
              <el-date-picker
                prefix-icon="1"
                :disabled="EM_IF == 'CK'"
                v-model="form.Reorientation_Date"
                type="date"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="上级WWID">
              <el-input :disabled="true" v-model="form.LineManagerWWID" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="7">
            <el-form-item label="level">
                <el-input :disabled='true' v-model="form.Level_0" placeholder="请输入"></el-input>
              <el-select :disabled='true' v-model="form.Level_0" placeholder="请选择">
                <el-option label="0" value="0"></el-option>
                <el-option label="1" value="1"></el-option>
                <el-option label="2" value="2"></el-option>
                <el-option label="3" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- 2025-07-11 隐藏下面三部分 代码格式化显示全局更改 -->
        <!-- <el-row>
          <el-col :span="7">
            <el-form-item label="level1">
              <el-select :disabled="EM_IF == 'CK'" v-model="form.Level_1" placeholder="请选择" @change="province_change($event)">
                <el-option v-for="item in Level_1" :key="item.ID" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="level2">
              <el-select :disabled="EM_IF == 'CK'" v-model="form.Level_2" placeholder="请选择">
                <el-option v-for="item in Level_2" :key="item.ID" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="大区/小区">
              <el-input :disabled="true" v-model="form.Level_3and4" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- 2025-07-11 隐藏上面3部分 -->
        <!-- <el-row>
          <el-col :span="7">
            <el-form-item label="大区/小区">
              <el-cascader :disabled='true' v-model="form.Level_3and4" :options="Employee_list" style="width:250px"
                :props="{ value: 'Name', label: 'Name'}" @change="Level_3and4Change"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row> -->
        <br />
        <el-button @click="save('form')" v-if="EM_IF != 'CK'" v-preventReClick="3000" type="primary">保 存</el-button>
        <el-button @click="onBack()">返回</el-button>
      </div>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="approval_request_Put_Material_list.description"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="turn_approvals()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  Employee_QueryById,
  HcoAddHCO,
  HcoUpdataHCO,
  approval_requestGetApprovalInfoByID,
  HcoApproval,
  HcoHcoExportExcel,
  regionGetRegionTree,
  EmployeePosition_QueryList,
  EmployeeRegionGetEmployeeRegionTrees,
  //   EmployeePosition_QueryList,
  EmployeeUpdateEmplovee,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      Employee_list: [],
      Level_1: [],
      Level_2: [],
      city_list: [],
      region_list: [],
      fileList: [],
      crystal_position_code_options: [],
      approval_request_Put_Material_list: {
        approval_data_id: this.$route.query.approval_data_id,
        type: '已通过',
        state: 0,
        approvalstate: false,
        description: '',
      },
      dialogVisible: false,
      Sales_analytics_msg: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      EM_IF: this.$route.query.type,
      SP_IF: this.$route.query.status,
      token: {},
      form: {},
      editFormRules: {
        // PostID: [{ required: true, message: '请选择', trigger: 'blur' }],
        // Nane: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_0: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_1: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_2: [{ required: true, message: '请选择', trigger: 'blur' }],
        // BU: [{ required: true, message: "请选择", trigger: "blur" }],
        Level_3and4: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    crystal_position_change(e) {
      console.log(e)
      this.crystal_position_code_options.find((item) => {
        if (item.Code === this.form.PostID) {
          console.log(item)
          this.form.Level_3and4 = item.large_region_name + '/' + item.small_region_name
          this.form.Level_1 = item.Level_1
          this.form.Level_2 = item.Level_2
          if (item.Level_1 == 'CAR') {
            this.form.BU = '晶体事业部'
          } else if (item.Level_1 == 'FLS&OSD') {
            this.form.BU = '飞秒激光及眼表事业部'
          }
          //
        }
      })
    },
    // Level_3and4Change (e) {
    //   this.form.Level_3 = e[0]
    //   this.form.Level_4 = e[1]
    //   console.log(e)
    // },
    // async submit_node(){
    //    const {data} = EmployeeUpdateEmplovee (this.form)
    //    if (data.success){
    //           this.$message({
    //             message:data.msg,
    //             type: "success",
    //           });
    //           this.dialogVisible= false
    //         } else{
    //           this.$message({
    //             message: data.msg,
    //             type: "error",
    //           });
    //         }

    // },
    btn_up_1(e) {
      window.open('/' + e)
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.form.cityid = item.id
          // this.city_list = item.children
        }
      })
    },
    province_change(e) {
      var level_1_ = this.Level_1.find((item) => {
        return item.Name == e
      })
      if (level_1_) {
        this.Level_2 = level_1_.children
      }
    },
    async crystal_position_code_chage(e) {
      const { data } = await EmployeePosition_QueryList({
        code: e,
      })
      this.crystal_position_code_options = data.response
      console.log(this.HospitalName_options)
      console.log(data)
    },
    onBack() {
      this.$router.push(this.$route.query.back_url)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },

    // 审批接口
    approval_request_Puts() {
      console.log(this.approval_request_Put_Material_list)
      HcoApproval(this.approval_request_Put_Material_list).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.$router.push({ path: this.back_url })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    turn_approvals() {
      //   this.approval_request_Put_Material_list.state = -1;
      //   this.approval_request_Put_Material_list.type = "已驳回";
      this.approval_request_Put_Material_list.approvalstate = false
      this.approval_request_Puts()
    },
    submit_approvals() {
      //   this.approval_request_Put_Material_list.state = 0;
      this.approval_request_Put_Material_list.approvalstate = true
      this.$confirm('确认同意？')
        .then((_) => {
          this.approval_request_Puts()
        })
        .catch((_) => {})
    },
    // 审核进度
    approval_request_Get(id) {
      // console.log(this.$route.query.type_accu);
      let para_s = {}
      para_s = {
        approval_data_id: this.$route.query.approval_data_id,
      }
      approval_requestGetApprovalInfoByID(para_s).then((res) => {
        if (res.data.response) {
          let num_zt = 0
          for (var i in res.data.response.ApprovalDataInfoList) {
            if (res.data.response.ApprovalDataInfoList[i].adireason == 0) {
              num_zt++
            }
            if (res.data.response.ApprovalDataInfoList[i].adireason == '-1') {
              this.description_text = res.data.msg
            }
          }
          // if (res.data.response[2].state == "-1") {
          //   this.description_text = res.data.msg;
          // }
          this.num_zt = num_zt
          // console.loe(999)
          this.request_list = res.data.response
          //   if (res.data.response)
          //   {
          //     this.request_list_name = res.data.response[0].username;
          //   }
          //   console.log(this.request_list.length);
          //   for (var i in this.request_list)
          //   {
          //     console.log(this.request_list[i].createtime);
          //     this.request_list[i].createtime = this.formattime(
          //       this.request_list[i].createtime
          //     );
          //     this.request_list[i].timestamp = this.formattime(
          //       this.request_list[i].timestamp
          //     );
          //   }
        }
      })
    },
    async save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          var { data } = await EmployeeUpdateEmplovee(this.form)
          //   }
          if (data.status == 200) {
            this.$message({
              message: data.msg,
              type: 'success',
            })
            this.$router.push(this.$route.query.back_url)
          } else {
            this.$message({
              message: data.msg,
              type: 'error',
            })
          }
        } else {
          return
        }
      })
    },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        this.form.file_urls = file.response
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    ExportAccount() {
      let para = this.filters
      HcoHcoExportExcel(para).then((res) => {
        window.location.href = res.data.msg
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    //获取用户列表
    getDetails() {
      console.log(this.$route.query.id)
      Employee_QueryById({ id: this.$route.query.id }).then((res) => {
        this.form = res.data.response
        this.province_change()
        this.form.Level_3and4 = this.form.Level_3 + '/' + this.form.Level_4
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn() {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees()
      this.Level_1 = data.response
    },
  },
  mounted() {
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    this.regionGetRegionTree_fn()
    this.EmployeeRegionGetEmployeeRegionTrees_fn()
    if (this.$route.query.type != 'ADD') {
      this.getDetails()
    }
    if (this.$route.query.type == 'CK') {
      this.approval_request_Get(this.$route.query.id)
    }
    // this.EmployeeRegionGetEmployeeRegionTrees_fn()
  },
}
</script>

<style scoped>
.demo-input-suffix {
  display: inline-block;
  margin-right: 15px;
}
.demo-input-suffix > .el-input {
  width: 150px;
  margin-bottom: 20px;
}
.stores >>> .el-select,
.stores >>> .el-date-editor {
  width: 100%;
}
.el-form-item__error {
  top: 19% !important;
  right: -29% !important;
}
</style>
